module.exports = __webpack_public_path__ + "media/img/frontend_application/data-deals-icon-883f3db6741e16c4fd600d5b6d35270d.png";